import axios from "axios";

const GENERIC_AXIOS_MESSAGE = /^Request failed with status code \d+$/;

/** Read user-facing message from backend API errors (axios 4xx/5xx). */
export function getApiErrorMessage(
  error: unknown,
  fallback = "Something went wrong"
): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as Record<string, unknown> | undefined;

    const validation = data?.validation;
    if (validation && typeof validation === "object" && !Array.isArray(validation)) {
      const parts = Object.entries(validation as Record<string, unknown>)
        .map(([key, value]) => {
          const text = typeof value === "string" ? value.trim() : "";
          return text ? `${key}: ${text}` : "";
        })
        .filter(Boolean);
      if (parts.length) return parts.join("; ");
    }

    const message =
      typeof data?.message === "string" ? data.message.trim() : "";
    if (message) return message;

    const apiError =
      typeof data?.error === "string" ? data.error.trim() : "";
    if (apiError) return apiError;

    if (Array.isArray(data?.errors)) {
      const first = data.errors.find((e) => typeof e === "string") as
        | string
        | undefined;
      if (first?.trim()) return first.trim();
    }
  }

  if (
    error instanceof Error &&
    error.message.trim() &&
    !GENERIC_AXIOS_MESSAGE.test(error.message.trim())
  ) {
    return error.message.trim();
  }

  return fallback;
}
